
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`هذا مُقدم من مشروع محرك Folksonomy Engine
                    <a href="${0}"></a>. لا تتردد
                    في المشاركة أو إبداء رأيك.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`تتيح لك هذه الأداة تصحيح قائمة المكونات. يمكنك إضافة أو إزالة أو تعديل قائمة المكونات
                .
                <br>
                هذا الرمز <span class="highlight">␣</span> يمثل مسافة.
                <br>
                هذا الرمز <span class="highlight">↩︎</span> يمثل فاصلًا للسطر. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `جاري تحميل الخصائص...`,
's000d98595e959c1e': `احصل عليه من Google Play`,
's013bdc8cf0d3583d': `ساعدنا في الحصول على المكونات`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `التحقق من صحة المحصول`,
's03e9c8114521b998': `سأقوم بتعديل المكونات`,
's05ec315d9308091a': `أيقونة زوايا الباركود`,
's061eb5af92512c85': `تم الحفظ! هل يمكنك مساعدتي في واحدة أخرى؟`,
's06847c221c4c0bc1': `أرغب في إنشاء خاصية لـ [وصف حالة الاستخدام الخاصة بك]...`,
's06f6c6f99db6b552': `إبداعي`,
's081e2ad82db71e1d': `القيم المجمعة`,
's09205907b5b56cda': `لا`,
's0b4235aae602a950': `وثائق مخصصة`,
's0bb2d48532acc455': `تنزيل ملف CSV`,
's0d5b7fee0311db68': `ملكية`,
's0fb218abc2e157ed': `إبطال الصورة`,
's100c4928cc74642a': `دعم تقدم أبحاث الصحة العامة.`,
's10db5498186c083b': `إلغاء الاقتصاص`,
's11a18a69b30b65ed': `ساعدنا في إصلاح الأخطاء في قائمة المكونات`,
's1205d5f6fccf8e69': `قيمة العقار`,
's15d64a0a6715285a': `مفتاح جديد`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `منطقة الاختيار`,
's1a52515ec8ddade8': `الباركود الخاص بالمنتج`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `ساعدنا في تصحيح المعلومات الغذائية`,
's1e00019dc454872d': `يرجى تقديم اسم الخاصية باستخدام سمة property-name.`,
's1e49126af0935a5b': `قائمة المنتجات التي تستخدم هذه الخاصية`,
's21e73088de6f26f3': `التحميل من على App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `إلغاء`,
's2db7b654c0a9bde0': `توثيق الممتلكات`,
's300b3a6ee4e1252d': str`مباراة سيئة ${0}%`,
's33f786bb6b4f0cf4': `نتيجة المحصول`,
's33f85f24c0f5f008': `حفظ`,
's34be4af4e8fec4ae': `اسأل المجتمع أولاً`,
's36d86adc823cbfa6': `قبل إنشاء عقار جديد، ناقشه مع المجتمع:`,
's3781d25aa51a736c': `توثيق محرك Folksonomy`,
's383ae4449428b61e': `إعادة ضبط المحصول`,
's39bcf88721a1e8ee': `إعادة تعيين الاختيار`,
's39e14e14300694c7': `التوثيق والمبادئ التوجيهية`,
's3b430cfa5c1fe7f4': str`توثيق ${0}`,
's3f4e4b52f230a892': `قماش الصورة`,
's417b90913e05bc17': `معاينة`,
's41f7dca46d3f1b4a': `القيمة`,
's422bba9636ce2489': `الصورة المركزية`,
's42dd66b2441566fd': `أيقونة المركز`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `إضافة مادة غذائية`,
's453ab0dbb9b5c777': `تغيير الحجم إلى اليمين`,
's475b08749d0706ed': `ساعدنا في إعلام ملايين المستهلكين حول العالم بما يأكلون`,
's49730f3d5751a433': `تحميل...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `عدد المنتجات`,
's4df2f533c0c1e7d0': `عناصر التحكم في الصورة`,
's4e94adf723979402': `Open Food Facts بحاجة إلى مساعدتك في هذا المنتج.`,
's4f4886341969d552': `نقل التحديد`,
's4f751fb9b3ed766c': `إنشاء عقار جديد`,
's547c12ae169d00bc': `متوفر على F-Droid`,
's5560fb119e40923d': `أدخل اسم الخاصية...`,
's55d7249883a98ca1': `حول هذه الخاصية على ويكي حقائق الطعام المفتوحة`,
's565867d84c04aea2': `خصائص الفلتر...`,
's5666afe5cd0166de': `يرجى تصحيح الأخطاء أو تعديل النص قبل التأكيد`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `جاري تحميل المنتجات...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `ساعدنا في تصحيح المعلومات الغذائية.`,
's5dd6f12783fca34f': `تعديل قائمة المكونات`,
's5e8250fb85d64c23': `إغلق`,
's5ed03bb1f3a15949': `صورة`,
's6306a31415aea913': `انا ادعم`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `تحرير`,
's66413c24dcf680e2': `تخطي`,
's67ae6594857a4d57': `شكرا لمساهمتك!`,
's6cee7cad81dfedd1': `صورة مقصوصة`,
's6d7b6cdedaadfb6e': `كل تبرع يُحسب! نقدّر دعمكم لتعزيز الشفافية الغذائية في العالم.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`تطابق جيد ${0}%`,
's71a5c9f4b68ef4d4': `عدّ`,
's74cb3d66f6a668e1': `التوثيق`,
's787dd11bed0dc88a': `تغيير الحجم إلى اليسار`,
's7ce4fd9430e80cea': `قيمة`,
's801a05fa8e881f37': `تعرف على المزيد حول إنشاء الممتلكات والمبادئ التوجيهية:`,
's8038273de2cf8b73': `الرجاء تحديد المنطقة التي تريد اقتصاصها.`,
's839cc2908a5387f2': `تصفية الباركود...`,
's86197dcf3e96af64': `تصفح والبحث عن العقارات الموجودة`,
's8a63be30a129a59c': `تغيير حجم الجزء السفلي`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `تغيير حجم الجزء العلوي الأيمن`,
's8db84aa4bc949af2': `توثيق الملكية الجديدة`,
's8f839a03997a16d7': `عرض المنتج`,
's901ae1e236ac45d3': `إلغاء الحذف`,
's907f7a97c6b29425': `انتبه، قد يتم تعديل نموذج البيانات. استخدمه على مسؤوليتك الخاصة.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `مكونات :`,
's9a7f60fce090ecaf': `تعذّر تحميل الخصائص. يُرجى المحاولة لاحقًا.`,
's9b87abd68fb9df45': `لم يتم العثور عليه؟ أنشئ مفتاحًا جديدًا {value}`,
's9c0f52425fd2f07e': `قد لا يتطابق`,
's9fc41f789c63b40d': `المنتجات`,
'sa1fa766e0d5634d7': `لا يوجد نتيجة متاحة`,
'sa548778b24054030': `استكشف جميع الخصائص المساهمة من مشروع Folksonomy Engine. توفر هذه الخصائص بيانات تعريفية إضافية ومعلومات قيّمة حول المنتجات في قاعدة بيانات Open Food Facts.`,
'sa63907958bd0ec4b': `تغيير حجم الجزء العلوي الأيسر`,
'sa95b4224f685a36a': `إغلاق النافذة المنبثقة`,
'sab56a1d439576fd6': `أيقونة الاقتراح`,
'sac47ea2901d04c15': `تغيير حجم الجزء السفلي الأيسر`,
'sb125227d436c2925': `ابحث عن مفهوم العقار الخاص بك في قاعدة بيانات العقارات الموجودة:`,
'sb125568d43642e6f': `الإجابة على الأسئلة المتعلقة بالمنتج.`,
'sb1c538e038f9b214': str`تطابق جيد جدًا ${0}%`,
'sb28639570ff3b852': `قائمة بجميع الخصائص`,
'sb3bdd638a58d30f4': `إشراك مجتمع من المواطنين الملتزمين،`,
'sb3cbcc1bd0fff140': `بمجرد التأكد من عدم وجود ملكيتك وموافقة المجتمع على أنها مفيدة، يتعين عليك أولاً توثيقها في الويكي.`,
'sb3d4f79d9d8b71e5': `إرسال`,
'sb560fa37a7bfb6c2': `لم يتم العثور على منتجات لهذه الخاصية.`,
'sb7f72e4c8a2d3357': `قيم الفلتر...`,
'sb8178320160f84ea': `عرض المحصول`,
'sbad7d2734149470b': `التحقق`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `تم الرد على جميع استفساراتك! شكرًا لمساعدتك!`,
'sbd9a0b2293b3cd3c': `حجم الحصة`,
'sbe472dc3c2685985': `القيمة المقابلة`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `تغيير حجم الجزء العلوي`,
'sc1c08d0cbcc3bd24': `لا يتطابق`,
'sc52696641af72b53': `ثبّت التطبيق!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `الإصلاح المقترح`,
'sc681b137e8f604f7': `تأكيد الحذف`,
'sc6daf8a31883f8b9': `نقل الصورة`,
'sc895972c88d38ca5': `ملكية فولكسونومي`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `الصفوف`,
'scb3b0671d7b7f640': `قيمة جديدة`,
'scb489a1a173ac3f0': `نعم`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `انضم إلى مناقشة Slack`,
'scdb6cad0b92721bf': `لم يتم العثور على أي خصائص.`,
'scf23a05631f93732': `تأكيد الحذف`,
'scfed2f270ef6a3aa': `حدد المنطقة`,
'sd1022bc1ef9204f7': `صورة قابلة للتكبير`,
'sd1077c055cf9ba6b': `ساعدنا في التحقق من صحة قائمة مكونات المنتج.`,
'sd698d21ddecba56b': `أهلاً! يمكنك مساعدتنا في تحسين معلومات المنتج بالإجابة على الأسئلة التالية:`,
'sd82bc2decefa621b': `ظل مستقلا عن صناعة الأغذية،`,
'sdb97e5976482606e': `التحقق مما إذا كانت الخاصية موجودة بالفعل`,
'sdbf806fefc584115': `يجب عليك أن تجد`,
'sdc673e73b5c13aea': `حذف`,
'sdc792b75f1edcaba': `ساعدنا في تصحيح تهجئة المكونات.`,
'sdca5deead576ceee': `تغيير حجم أسفل اليمين`,
'sdcc2555c5dde524f': `هل أنت متأكد أنك تريد حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.`,
'se206feec7ec57b28': `لكل 100 غرام`,
'se419a9ab36987490': `إبطال`,
'se5127cf0f92e7e48': `نصيحة: يمكنك أيضًا العثور على`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `سأقترح محصولا أفضل`,
'seea3800e27baa686': `المنتجات الفردية`,
'sefaba4adc4ec9219': `خصائص علم الفلك`,
'seffa8ca49175b5f0': `خصائص مخصصة`,
'sf44a6b3b232c28ea': str`استبدال القيمة الحالية بـ ${0}`,
'sf4cd86a2f5ef2588': `رمز المنتج الشريطي`,
'sf57a61152168cc81': `ساعدنا في تصحيح اكتشاف المكونات`,
'sf88b90b8ba23871c': `مباراة غير معروفة`,
'sf9aee319a006c9b4': `إضافة`,
'sfacbbe968fa7d773': `اسم العقار:`,
'sfc40ea3d5d5aa6f8': `تساهم تبرعاتكم في تمويل العمليات اليومية لجمعيتنا غير الربحية:`,
'sfe87465d50530725': `القيمة المقابلة`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  